import { createUseStyles } from 'react-jss';

export default createUseStyles({
  uploadFileOptionWithoutImage: {
    '& >span:first-of-type': {
      top: '-30px',
      '@media (max-width: 767px)': {
        top: '-12px',
      },
    },
  },
  uploadFileOptionWithImage: {
    '& >span:first-of-type': {
      top: '-18px',
    },
  },
  uploadFileOptionWithError: {
    '& >span:first-of-type': {
      top: '-40px',
      '@media (max-width: 767px)': {
        top: '-22px',
      },
    },
  },
});
